<template>
  <div class="container">
    <div class="row">
      <div class="overviewAndNav">
        <h3>Overzicht {{ this.currentlySelectedMonth | toMonthNameWithYear }}</h3>
        <div class="col-lg-4">
          <button
              class="btn btn-dark" @click="previousMonth">
            <svg
                class="bi bi-chevron-left" fill="currentColor"
                height="1em" viewBox="0 0 16 16"
                width="1em" xmlns="http://www.w3.org/2000/svg">
              <path
                  d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"
                  fill-rule="evenodd"/>
            </svg>
          </button>
          <button
              class="btn btn-dark mr-2" @click="nextMonth">
            <svg
                class="bi bi-chevron-right" fill="currentColor"
                height="1em" viewBox="0 0 16 16"
                width="1em" xmlns="http://www.w3.org/2000/svg">
              <path
                  d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"
                  fill-rule="evenodd"/>
            </svg>
          </button>
        </div>
        <button class="btn-basic btn-outline-pulse-dark button-showPulse" @click="togglePulseRows">
          {{ hidePulseRows ? 'Toon Pulse' : 'Verberg Pulse' }}
        </button>
      </div>
    </div>
    <div class="row my-2">
      <input
          ref="focusMe"
          type="text"
          class="form-control"
          placeholder="Zoeken op naam..."
          v-model="search"/>
    </div>

    <div class="table-responsive">
      <b-table-simple hover small caption-top bordered no-border-collapse>
        <caption>Uurtarieven per persoon per contract:</caption>
        <b-thead head-variant="dark">
          <b-tr>
            <b-th colspan="2">Info</b-th>
            <b-th v-bind:colspan=viewHourlyRateInfo.nrOfDaysInMonth>Dag van de maand</b-th>
          </b-tr>
          <b-tr>
            <SortableTableHeaderComponent
                class="sticky-top"
                columnName="userName" :sortColumn="currentSortColumn"
                :sortDirectionAscending="currentSortDirectionAscending" :sortFunction="sort"
                text="Naam"/>
            <b-th class="sticky-top">Contract</b-th>
            <b-th class="sticky-top" v-for="n in viewHourlyRateInfo.nrOfDaysInMonth" v-bind:key="n">{{ n }}</b-th>
          </b-tr>
        </b-thead>
        <b-tbody v-for="(user, i) in filteredUserNames" v-bind:key="i">
            <b-tr v-for="(contract, index) in user.hourlyRatesInfo" v-bind:key="index">
              <b-th v-if="index === 0" :rowspan="user.hourlyRatesInfo.length">{{ user.userName }}</b-th>
              <b-th class="text-right">{{ contract.customerName }}</b-th>
              <template v-for="hourlyRatePerDay in Object.entries(contract.hourlyRatesPerDay)">
                <b-td v-if="hourlyRatePerDay[1]" variant="success" v-bind:key="hourlyRatePerDay[0]">{{ hourlyRatePerDay[1] }}</b-td>
                <b-td v-else variant="danger" v-bind:key="hourlyRatePerDay[0]"></b-td>
              </template>
            </b-tr>
        </b-tbody>
      </b-table-simple>
    </div>

  </div>
</template>

<script>
import {mapActions, mapGetters, mapMutations} from "vuex";
import {sortListByColumnAndDirection} from "@/util/SortingUtil";
import SortableTableHeaderComponent from "@/components/tables/SortableTableHeader";

export default {
  name: "AdminContractViewComponent",
  components: {
    SortableTableHeaderComponent,
  },
  data: () => ({
    currentSortColumn: "userName",
    currentSortDirectionAscending: true,
    search: '',
    hidePulseRows: false,
  }),
  computed: {
    ...mapGetters({
      viewHourlyRateInfo: 'administrationTimeSheet/viewHourlyRateInfo',
      currentlySelectedMonth: "time/currentlySelectedMonth"
    }),
    filteredUserNames() {
      let usersWithHourlyRateInfo = sortListByColumnAndDirection(
          this.viewHourlyRateInfo.usersWithHourlyRateInfo,
          this.currentSortColumn,
          this.currentSortDirectionAscending
      );

      let filteredUsers = usersWithHourlyRateInfo.filter(userWithHourlyRateInfo => {
        return userWithHourlyRateInfo.userName.toLowerCase().includes(this.search.toLowerCase());
      });

      return filteredUsers.map(user => {
        let filteredHourlyRatesInfo = user.hourlyRatesInfo;

        if (this.hidePulseRows) {
          filteredHourlyRatesInfo = filteredHourlyRatesInfo.filter(contract =>
              !contract.customerName.toLowerCase().includes('pulse')
          );
        }

        return {
          ...user,
          hourlyRatesInfo: filteredHourlyRatesInfo
        };
      });
    },
  },
  watch: {
    hidePulseRows(newValue) {
      sessionStorage.setItem('hidePulseRows', newValue);
    }
  },
  async created() {
    await this.fetchViewHourlyRateInfo();
    const hidePulseRows = sessionStorage.getItem('hidePulseRows');
    this.hidePulseRows = hidePulseRows === 'true';
  },
  methods: {
    ...mapActions("administrationTimeSheet", ["fetchContractWithTimeSheetInfo", "fetchViewHourlyRateInfo"]),
    ...mapMutations({
      addMonth: "time/addMonth",
      subtractMonth: "time/subtractMonth"
    }),
    sort: function (newSortColumn) {
      if (newSortColumn === this.currentSortColumn) {
        this.currentSortDirectionAscending = !this.currentSortDirectionAscending;
      } else {
        this.currentSortDirectionAscending = true;
      }
      this.currentSortColumn = newSortColumn;
    },
    previousMonth() {
      this.subtractMonth();
      this.fetchViewHourlyRateInfo();
    },
    nextMonth() {
      this.addMonth();
      this.fetchViewHourlyRateInfo();
    },
    togglePulseRows() {
      this.hidePulseRows = !this.hidePulseRows;
    }
  },
};
</script>

<style scoped>

.overviewAndNav {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

td {
  vertical-align: middle;
}

</style>
